export const ACCOUNT_REFUND_PATH = '/account/refund';
export const ACCOUNT_DISTRIBUTION_PATH = '/account/distribution';
export const ACCOUNT_TRANSFER_HISTORY_PATH = '/account/transfers';
